export const VALIDATION_ERRORS = {
  noFeatureName: 'errors.noFeatureName',
  noFeatureType: 'errors.noFeatureType',
  minFeatureName: 'errors.minFeatureName',
  maxFeatureName: 'errors.maxFeatureName',
  noProductsSelected: 'errors.noProductsSelected',
  noSharingOptionSelected: 'errors.noSharingOptionSelected',
  noIncludeRecipient: 'errors.noIncludeRecipient',
  noRecipient: 'errors.noRecipient',
  noTableRecipients: 'errors.noTableRecipients',
  noTableTags: 'errors.noTableTags',
  noTableRecipientsOrTags: 'errors.noTableRecipientsOrTags',
  noRecipientQuantity: 'errors.noRecipientQuantity',
  noSecuritySetting: 'errors.noSecuritySetting',
  minEmailDomain: 'errors.minEmailDomain',
  minEmailList: 'errors.minEmailList',
  minEndDate: 'errors.minEndDate',
  noEndDate: 'errors.noEndDate',
  noSenderName: 'errors.noSenderName',
  minSenderName: 'errors.minSenderName',
  maxSenderName: 'errors.maxSenderName',
  noSubjectLine: 'errors.noSubjectLine',
  minSubjectLine: 'errors.minSubjectLine',
  maxSubjectLine: 'errors.maxSubjectLine',
  noGiftCardMessage: 'errors.noGiftCardMessage',
  invalidGiftCardMessage: 'errors.invalidGiftCardMessage',
  minGiftCardMessage: 'errors.minGiftCardMessage',
  minAboutMessage: 'errors.minAboutMessage',
  maxAboutMessage: 'errors.maxAboutMessage',
  noLogoSelected: 'errors.noLogoSelected',
  noGiftWrapperSelected: 'errors.noGiftWrapperSelected',
  noPaymentMethod: 'errors.noPaymentMethod',
  noSendSchedule: 'errors.noSendSchedule',
  noRedemptionWindow: 'errors.noRedemptionWindow',
  noSelectedCharity: 'errors.noSelectedCharity',
  noSelectedCharitySku: 'errors.noSelectedCharitySku',
  noEnteredInviteEmail: 'errors.noEnteredInviteEmail',
  hasInvalidInviteEmail: 'errors.hasInvalidInviteEmail',
  noEnteredInviteRole: 'errors.noEnteredInviteRole',
  existingOrganizationUser: 'errors.existingOrganizationUser',
  missingContactInformation: 'errors.missingContactInformation',
  missingRecipientInformation: 'errors.missingRecipientInformation',
  uploadSpreadsheet: 'errors.uploadSpreadsheet',
  noDigitalCard: 'errors.noDigitalCard',
  noGiftCardOrDigitalCardMessage: 'errors.noGiftCardOrDigitalCardMessage',
  noProvidedInformation: 'errors.noProvidedInformation',

  minFirstName: 'errors.minFirstName',
  maxFirstName: 'errors.maxFirstName',
  noFirstName: 'errors.noFirstName',
  minLastName: 'errors.minLastName',
  maxLastName: 'errors.maxLastName',
  noLastName: 'errors.noLastName',
  minEmail: 'errors.minEmail',
  maxEmail: 'errors.maxEmail',
  noEmail: 'errors.noEmail',
  invalidEmail: 'errors.invalidEmail',
  invalidPassword: 'errors.invalidPassword',
  invalidConfirmPassword: 'errors.invalidConfirmPassword'
};
